import { z } from 'zod/v4'

export const WORKSPACE_OWNER_ROLE = 'stytch_admin'
export const WORKSPACE_EDITOR_ROLE = 'workspace_editor'
export const WORKSPACE_VIEWER_ROLE = 'workspace_viewer'
export const StytchWorkspaceRoleValidator = z.enum([
	WORKSPACE_OWNER_ROLE,
	WORKSPACE_EDITOR_ROLE,
	WORKSPACE_VIEWER_ROLE,
])

export const CreateStytchWorkspaceValidator = z.object({
	name: z.string(),
	slug: z.string().optional(),
})

export const StytchWorkspaceMemberValidator = z.object({
	id: z.string(), // member_id from Stytch
	email: z.string(),
	name: z.string().optional(),
	role: StytchWorkspaceRoleValidator,
	status: z.enum(['pending', 'active', 'inactive']),
	joined_at: z.string(),
})

export const InviteStytchMemberValidator = z.object({
	email_address: z.email(),
	name: z.string().optional(),
	roles: z.array(z.string()).optional(),
})

export const UpdateStytchMemberRoleValidator = z.object({
	role: StytchWorkspaceRoleValidator,
})

// Type exports
export type StytchWorkspaceRole = z.infer<typeof StytchWorkspaceRoleValidator>
export type CreateStytchWorkspace = z.infer<typeof CreateStytchWorkspaceValidator>
export type StytchWorkspaceMember = z.infer<typeof StytchWorkspaceMemberValidator>
export type InviteStytchMember = z.infer<typeof InviteStytchMemberValidator>
export type UpdateStytchMemberRole = z.infer<typeof UpdateStytchMemberRoleValidator>
